// реально any
/* oxlint-disable typescript/no-explicit-any */
export function noopReducer(defaults: any = null) {
  return (state: any) => state || defaults;
}
